import { render, staticRenderFns } from "./CareerMatch.vue?vue&type=template&id=a77c9aee&scoped=true"
import script from "./CareerMatch.vue?vue&type=script&lang=js"
export * from "./CareerMatch.vue?vue&type=script&lang=js"
import style0 from "./CareerMatch.vue?vue&type=style&index=0&id=a77c9aee&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a77c9aee",
  null
  
)

export default component.exports